export default __webpack_public_path__ + "static/avatar-lavinia-7a2b01eae6dd287609f79876d192ce8a.png";